<template>
  <v-dialog width="600" v-model="dialog" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn @click="copyObject" v-bind="attrs" v-on="on" icon>
        <v-icon color="blue">mdi-square-edit-outline</v-icon>
      </v-btn>
    </template>
    <v-card class="rounded-lg">
      <v-card-title class="pb-0">
        <v-row align="center" justify="space-between">
          <v-col class="px-0" cols="auto"></v-col>
          <v-col class="px-0" cols="auto">
            <p class="dialog-title">Редактирование планшета</p>
          </v-col>
          <v-col class="px-0" cols="auto">
            <v-btn icon @click="resetState">
              <v-icon size="30" color="error">mdi-close-thick</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text style="padding: 15px 40px">
        <v-form v-model="valid" valid>
          <div class="input-wrapper">
            <label for="branch">Филиал <span class="red--text">*</span></label>
            <v-select
              placeholder="Выберите филиал"
              v-model="device.branch_id"
              :rules="rules.select"
              :items="branch"
              item-text="title"
              item-value="id"
              id="branch"
              outlined
            ></v-select>
          </div>
          <div class="input-wrapper">
            <label for="status">Статус <span class="red--text">*</span> </label>
            <v-select
              placeholder="Укажите статус"
              v-model="device.status"
              :rules="rules.select"
              :items="status"
              item-text="name"
              item-value="id"
              id="status"
              outlined
              dense
            ></v-select>
          </div>
          <div class="input-wrapper">
            <label for="branch_id">Расположение </label>
            <v-select
              v-model="device.entrance_type"
              :items="entrance_type"
              item-text="name"
              item-value="id"
              outlined
              dense
            ></v-select>
          </div>
          <v-btn
            @click="updateDevice"
            :disabled="!valid"
            class="save-btn"
            depressed
            >Сохранить</v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "UpdateDevice",
  props: {
    branch: {
      type: Array,
      required: true,
    },
    deviceDefault: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      status: ["AVAILABLE", "UNAVAILABLE"],
      entrance_type: ["AT_ENTRANCE", "AT_EXIT", "NOT_DEFINED"],
      device: {},
      dialog: false,
      valid: false,
      rules: {
        required: [(v) => !!v || "Поле обязательно для заполнения"],
      },
    };
  },
  methods: {
    copyObject() {
      Object.assign(this.device, this.deviceDefault);
      // this.device.branch_id = this.deviceDefault.branch.id;
      // this.device.entrance_type = this.deviceDefault.entrance_type
    },
    resetState() {
      this.device = {};
      this.dialog = false;
    },
    async updateDevice() {
      try {
        await this.$axios.post(
          `devices/${this.device.id}/update/`,
          this.device
        );
        this.$root.$emit("showCustomSuccess", "Планшет успешно изменён!");
        this.$emit("refreshData");
      } catch (result) {
        this.$root.$emit("showCustomError", result);
      } finally {
        this.resetState();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.create-item {
  width: 240px;
  height: 41px;

  font-family: Gilroy-Medium, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.1px;
  color: #ffffff;
  text-transform: none !important;
}
.dialog-title {
  font-family: Gilroy-Medium, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 31px;
  text-align: center;
  color: #3474d3;
}
.preview {
  position: relative;
  height: 125px;
  width: 125px;

  .delete-btn {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
